export default "__VITE_ASSET__ChX7EhS$__"